import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'enl-e5peter-example-lib',
  template: `
    <p>
      e5peter-example-lib works!
    </p>
  `,
  styles: []
})
export class E5peterExampleLibComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
